'use client'

import { type ComponentProps, Suspense } from 'react'

import dynamic from 'next/dynamic'

import type { SubscribeFormClient } from './subscribe-form-client'

// Split from a client boundary: a server import() still includes this form in
// every story route's initial bundle. Keep SSR for authored newsletter embeds.
const SubscribeForm = dynamic(() => import('./subscribe-form-client').then((module) => module.SubscribeFormClient))

export const SubscribeFormLazy = (props: ComponentProps<typeof SubscribeFormClient>) => (
  <Suspense
    fallback={
      <section {...props.editableProps} className="not-prose mx-auto my-8 w-full max-w-[880px]" aria-busy="true">
        <div className="bg-navy min-h-64 space-y-5 rounded-[28px] p-8 text-white">
          <p className="text-2xl font-semibold">{props.content.heading}</p>
          <p>{props.content.subheading}</p>
          <div aria-hidden className="h-14 rounded-2xl bg-white/10 motion-safe:animate-pulse" />
        </div>
      </section>
    }
  >
    <SubscribeForm {...props} />
  </Suspense>
)
